// @flow

import type { TokenizedCard } from '@tectonics/prs/card/tokenized';
import type { ConfirmedIncomingPayment, OpenedIncomingPayment, PendingIncomingPayment } from './types';

export function getTokenizedCard(incomingPayment: ConfirmedIncomingPayment | OpenedIncomingPayment | PendingIncomingPayment): ?TokenizedCard {
  return incomingPayment['card'];
}
